import { fmtUSD } from "@/lib/money";

const statusColor = (status) => {
  if (status === "paid") return "text-emerald-400";
  if (status === "pending") return "text-amber-400";
  return "text-red-400";
};

const TX_LABELS = { auto_refill: "Auto-refill", admin_grant: "Admin grant", call_charge: "Call charge", trial_grant: "Trial credits", call_hold: "Outbound call — credit block", call_refund: "Outbound call — unused minutes refunded" };
const DEBITS = new Set(["call_charge", "call_hold"]);

export const TransactionsList = ({ transactions }) => (
  <div className="border border-border bg-[#0A0A0A] rounded-sm p-6">
    <h2 className="font-heading text-lg font-black tracking-tight mb-4">Recent purchases</h2>
    {transactions.length === 0 ? (
      <p className="text-xs text-muted-foreground" data-testid="transactions-empty">No purchases yet.</p>
    ) : (
      <div className="space-y-2" data-testid="transactions-list">
        {transactions.map((tx) => (
          <div key={tx.id} className="flex items-center justify-between border-b border-border pb-2 last:border-0 last:pb-0">
            <div>
              <p className="text-sm">{TX_LABELS[tx.type] || "Credit purchase"}</p>
              <p className="text-[11px] text-muted-foreground font-mono">
                {new Date(tx.created_at).toLocaleString()}
              </p>
            </div>
            <div className="text-right">
              <p className={`font-mono text-sm font-bold ${DEBITS.has(tx.type) ? "text-red-400" : ""}`}>
                {DEBITS.has(tx.type) ? "−" : ""}{fmtUSD(tx.credits_amount)}
              </p>
              <p className={`text-[11px] font-mono ${statusColor(tx.payment_status)}`}>{tx.payment_status}</p>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
